import { defineRouting } from "next-intl/routing";

/**
 * 글로벌 서비스이므로 기본 로케일은 영어로 두고, 한국어·중국어를 함께 지원한다.
 * /api, /oauth 경로는 외부(Google/MS OAuth 콜백, MCP 에이전트 토큰 발급)와 맞물려 있어
 * 로케일 프리픽스를 붙이면 안 되므로 proxy.ts의 matcher에서 명시적으로 제외한다.
 */
export const routing = defineRouting({
  locales: ["en", "ko", "zh"],
  defaultLocale: "en",
});

export type AppLocale = (typeof routing.locales)[number];
